module.exports = __webpack_public_path__ + "static/media/eagm-steps-en.ad4ead9f.png";